import { fetchTrialExpirationDate } from "../helpers/fetch-trial-expiration-date";

export async function isTrialExpired(
  homePortalAppId?: string
): Promise<boolean> {
  const trialExpirationDate = homePortalAppId
    ? await fetchTrialExpirationDate(homePortalAppId)
    : null;

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ignore time part
  const trialExpired = new Date(trialExpirationDate + "T00:00:00") < today;

  return trialExpired;
}
